import { isFuture, isPast } from 'date-fns';
import { ENGLISH, FRENCH, GERMAN, PORTUGUESE, SPANISH } from '../config';
export var getEndOfUTCDay = function (date, count) {
    if (count === void 0) { count = 0; }
    var endTime = date === undefined ? new Date() : new Date(date);
    endTime.setUTCDate(endTime.getUTCDate() + count);
    endTime.setUTCHours(23, 59, 59, 999);
    return endTime;
};
export function getDateFormat(language) {
    switch (language) {
        case GERMAN:
            return 'DD.MM.YYYY';
        case ENGLISH:
            return 'M/D/YYYY';
        default:
            return 'DD/MM/YYYY';
    }
}
export function getDateFormatUnicode(language) {
    switch (language) {
        case GERMAN:
            return 'dd.MM.yyyy';
        case ENGLISH:
            return 'M/d/yyyy';
        default:
            return 'dd/MM/yyyy';
    }
}
export function getTimeFormat(language) {
    switch (language) {
        case PORTUGUESE:
            return 'kk:mm';
        case ENGLISH:
            return 'hh:mm a';
        case GERMAN:
            return 'kk:mm [Uhr]';
        case FRENCH:
            return 'kk[h]mm';
        case SPANISH:
            return 'kk:mm [h]';
        default:
            return 'k:mm';
    }
}
export function getTimeFormatUnicode(language) {
    switch (language) {
        case ENGLISH: {
            return 'hh:mm a';
        }
        case GERMAN: {
            return "HH:mm 'Uhr'";
        }
        case PORTUGUESE:
        case FRENCH: {
            return 'HH:mm';
        }
        case SPANISH: {
            return "HH:mm 'h'";
        }
        default: {
            return 'H:mm';
        }
    }
}
var isDateInput = function (date) {
    return Boolean(date) &&
        (date instanceof Date ||
            typeof date === 'number' ||
            typeof date === 'string');
};
var convertToDate = function (date) {
    if (typeof date === 'string' || typeof date === 'number') {
        return new Date(date);
    }
    return date;
};
var convertParametrsToDate = function (func) {
    return function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return func.apply(void 0, params.map(convertToDate));
    };
};
export var toISODateString = convertParametrsToDate(function (date) {
    return date.toISOString().slice(0, 10);
});
export var toISOTimeString = convertParametrsToDate(function (date) {
    return date.toISOString().slice(11, 19);
});
export function isSameUTCDay(date1, date2) {
    return (isDateInput(date1) &&
        isDateInput(date2) &&
        toISODateString(date1) === toISODateString(date2));
}
export var isPastAndTruthy = function (date) {
    return isDateInput(date) && isPast(convertToDate(date));
};
export var isFutureAndTruthy = function (date) {
    return isDateInput(date) && isFuture(convertToDate(date));
};
